import React from 'react'
import { IVehicleType } from '@cbgms/api'
import Box from '@mui/material/Box'
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline'
import Typography from '@mui/material/Typography'

export interface ISelectedVehicleSummaryProps {
  vehicle: Partial<IVehicleType>
}

export const SelectedVehicleSummary: React.FC<ISelectedVehicleSummaryProps> = ({ vehicle }) => {
  const vehicleSelectedTitle = React.useMemo(() => {
    const seperator = ' - '
    return [vehicle.Manufacturer, vehicle.Model, vehicle.Type].filter(el => !!el).join(seperator)
  }, [vehicle])

  return (
    <Box
      data-testid='selected-vehicle-summary'
      sx={{ py: 5, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}
    >
      <CheckCircleOutlineIcon color='success' sx={{ fontSize: '6rem' }} />
      <Typography variant='h6' textAlign='center' sx={{ my: 2 }}>
        {vehicleSelectedTitle}
      </Typography>
    </Box>
  )
}
